import React from 'react';
import * as constant from './constants';
import Button from './../Button';
import ImageButton from './../Button/ImageButton';
import FormGroup from './../FormGroup';
import Keyboard from './../Keyboard/Keyboard';
import { LocalTranslations } from '../../requests/apa/local';
import translatesJson from './Edit.translates.json';
import UtilsProfile from '../../utils/Profile';
import Utils from '../../utils/Utils';
import {
  trackProfilesEditSubmitted,
} from '../../services/datadog/profile';

const localTranslations = new LocalTranslations(translatesJson);

export const Edit = ({ props }) => {
  const inputName = 'firstName';
  const inputImage = 'userImage';
  const inputNameField = UtilsProfile.getField(props.fields, inputName);
  const inputImageField = UtilsProfile.getField(props.fields, inputImage);
  const imgSrc = UtilsProfile.changeProtocolURLImage(inputImageField.value)

  if (props.defaultFocus) {
    UtilsProfile.setFocus('.container.edit_profile .row.input .focusable');
  }

  return (
    <div className='container edit_profile'>
      <div className='col left'>
        <div className='row'></div>
        <div className='row keyboard'>
          <Keyboard currentValue={inputNameField.value}
            onClick={(text) => {
              props.setTextValue(text);
            }}/>
        </div>
      </div>
      <div className='col right'>
        <div className='row'></div>
        <div className='row title'>
          <span>{localTranslations.get('update_profile_title', 'Modificar perfil')}</span>
        </div>
        <div className='row avatar-option'>
          <ImageButton order={['text']} className='image' imgSrc={Utils.adaptImageProtocol(inputImageField.value)}
            focusable={false}
          />
          <Button order={['text']} className='button' text={localTranslations.get('change_profile_picture_btn', 'Modificar perfil')}
            onClick={() => {
              props.sendMetricProfile({
                event: constant.METRIC_EVENT,
                category: constant.METRIC_CATEGORY_START,
                action: constant.METRIC_ACTION_PROFILE,
                label: constant.METRIC_LABEL_CHANGEIMAGE,
              });
              props.onSetAction(constant.SELECT_PROFILE)
            }} />
        </div>
        <div className='row error'>
          <span className='error'>{inputImageField.error}</span>
        </div>
        <div className='row input'>
          <FormGroup
            id={inputName}
            value={inputNameField.value}
            error={inputNameField.hasError}
            message={inputNameField.error}
            placeholder={localTranslations.get('enter_profile_name_placeholder', 'Ingresa Nombre')}
            onFocused={() => {
              //setCurrentKey(inputName);
            }} />
        </div>
        <div className='row delete'>
          <Button order={['text']} className='button' text={localTranslations.get('delete_profile_btn', 'Eliminar perfil')}
            onClick={() => {
              props.sendMetricProfile({
                event: constant.METRIC_EVENT,
                category: constant.METRIC_CATEGORY_START,
                action: constant.METRIC_ACTION_PROFILE,
                label: constant.METRIC_LABEL_DELETEPROFILE,
              });
              props.showWarning(props.data);
            }} />
        </div>
        <div className='row button'>
          <Button order={['text']} className='button' text={localTranslations.get('cancel_update_profile_btn', 'Cancelar')}
            onClick={() => {
              props.onSetAction(constant.ADMIN_PROFILE)
            }} />
          <Button order={['text']} className='button' text={localTranslations.get('update_profile_btn', 'Aceptar')}
            onClick={() => {
              if (UtilsProfile.validateForm(props.fields, props.onFieldError)) {

                trackProfilesEditSubmitted({
                  username: inputNameField.value,
                  user_image: inputImageField.value,
                  gamification_id: props.data && props.data.gamification_id,
                });

                props.updateProfile({
                  username: inputNameField.value,
                  user_image: imgSrc,
                  gamification_id: props.data && props.data.gamification_id,

                });
                //props.onSetAction(constant.START)
              }
            }} />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/Profile/Edit.jsx